module.exports = __webpack_public_path__ + "img/weddingbands@2x.e6335c9.webp";